<div class="column-flex">
    <div class="form-label">
        {{ 'system-settings.eap.led.pattern-dialog.title' | translate }}
    </div>
    <div class="main-container">
        <div class="pattern-name-container">
            <div class="pattern-name-label">
                {{ 'system-settings.eap.led.pattern-dialog.name' | translate }}
            </div>
            <app-channel-text-input
                [name]="PATTERN_NAME"
                [value]="ledPattern.name"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.name"
                [maxLength]="30"
                [noLabel]="true"> 
            </app-channel-text-input>
        </div>
        <div class="led-section">
            <div class="section-title">
                {{ 'system-settings.eap.led.pattern-dialog.led-assignment' | translate }}
                <div class="sub-text">
                    {{ 'system-settings.eap.led.pattern-dialog.led-assignment.sub-text' | translate : { count: occupiedLedCount } }}
                </div>
            </div>
            <div class="led-list">
                <div class="led-row led-header">
                    <div class="led-number">
                        {{ 'system-settings.eap.led.pattern-dialog.led' | translate }}
                    </div>

                    <div class="function-container">
                        {{ 'system-settings.eap.led.pattern-dialog.function' | translate }}
                    </div>

                    <div class="configuration-container">
                        {{ 'system-settings.eap.led.pattern-dialog.configuration' | translate }}
                    </div>
                </div>
                <div class="table-container">
                    <div
                        class="led-row"
                        *ngFor="let config of ledConfigurations"
                    >
                        <div class="led-number">
                            {{ config.led }}
                        </div>
                        <div class="function-container">
                            <app-simple-dropdown
                                [style.width]="'70%'"
                                [options]="getFunctionOptions(config.led)"
                                [selectedOption]="getSelectedFunctionOption(config)"
                                (onOptionSelected)="onFunctionChanged(config, $event)"
                                [borderless]="true"
                                [smaller]="true">
                            </app-simple-dropdown>
                            <mat-icon svgIcon="delete" class="clear-button"  *ngIf="getSelectedFunctionOption(config)" (click)="clearFunction(config)"> </mat-icon>
                        </div>
                        <div class="configuration-container">
                            <ng-container *ngIf="config.function === eapLedFunction.ALARM">
                                <app-simple-dropdown
                                    [style.width]="'70%'"
                                    [options]="alarmGroupOptions"
                                    [selectedOption]="getAlarmGroupOption(config)"
                                    (onOptionSelected)="onAlarmGroupChanged(config, $event)"
                                    [borderless]="true"
                                    [smaller]="true">
                                </app-simple-dropdown>
                            </ng-container>
                            <ng-container *ngIf="config.function === eapLedFunction.MAN_UNMAN">
                                <app-simple-dropdown
                                    [style.width]="'70%'"
                                    [options]="manUnmanOptions"
                                    [selectedOption]="getManUnmanOption(config)"
                                    (onOptionSelected)="onManUnmanChanged(config, $event)"
                                    [borderless]="true"
                                    [smaller]="true">
                                </app-simple-dropdown>
                            </ng-container>
                            <ng-container *ngIf="config.function === eapLedFunction.WHO_DUTY">
                                <app-simple-dropdown
                                    [style.width]="'70%'"
                                    [options]="dutyRoleOptions"
                                    [selectedOption]="getDutyRoleOption(config)"
                                    (onOptionSelected)="onDutyRoleChanged(config, $event)"
                                    [borderless]="true"
                                    [smaller]="true">
                                </app-simple-dropdown>
                            </ng-container>
                            <ng-container *ngIf="config.function === eapLedFunction.ON_DUTY">
                                <app-simple-dropdown
                                    [style.width]="'70%'"
                                    [options]="onDutyOptions"
                                    [selectedOption]="getOnDutyOption(config)"
                                    (onOptionSelected)="onOnDutyChanged(config, $event)"
                                    [borderless]="true"
                                    [smaller]="true">
                                </app-simple-dropdown>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    config.function === eapLedFunction.ENGINEER_CALL ||
                                    !config.function
                                ">
                                <span class="no-configuration">
                                    -
                                </span>
                            </ng-container>
                            <mat-icon svgIcon="delete" class="clear-button"  *ngIf="hasConfiguration(config)" (click)="clearConfiguration(config)"> </mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="buttons-container">
        <div class="cancel button" (click)="cancel()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div
            class="create button"
            [ngClass]="{ button_disabled: isSaveDisabled }"
            (click)="save()">
            {{
                isEditing
                    ? ('dlg.edit' | translate)
                    : ('dlg.save' | translate)
            }}
        </div>
    </div>
</div>

<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'system-settings.eap.cancel.dialog.title'"
    [discardLabel]="'system-settings.eap.cancel.dialog.discard'"
    [goBackLabel]="'system-settings.eap.cancel.dialog.go-back'"
    [saveLabel]="'system-settings.eap.cancel.dialog.save'">
</app-confirmation-window>
